// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"9a663824","977":"d7ed7c72"}[chunkId] + ".chunk.js";
};